<template>
  <span>
    <template v-for="(tool, idx) of settings">
      <span :key="idx">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-checkbox
              hide-details
              @change="changeSingleSetting(tool.name, $event)"
              :input-value="settingsValues[tool.name]"
              :disabled="!moduleEnabled"
            >
              <template #label>
                <v-row no-gutters class="text-body-2" style="color: #202124 !important">
                  <v-col cols="auto" :class="{ 'text--disabled': !moduleEnabled }">
                    {{ $i18n.t(tool.titlePath, { moduleVerboseName }) }}
                  </v-col>
                </v-row>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="!tool.hideSubtitle" no-gutters>
          <v-col cols="auto" style="padding-left: 32px">
            <italic-subheader
              :translation-path="tool.subtitlePath ? tool.subtitlePath : 'admin.moduleSubSettingSubtitle'"
              :params="{ moduleVerboseName, toolVerboseName: $i18n.t(tool.titlePath, { moduleVerboseName }) }"
            />
          </v-col>
        </v-row>
      </span>
    </template>
  </span>
</template>
<script>
import { call, get } from 'vuex-pathify';
import ItalicSubheader from '@/components/ItalicSubheader';
export default {
  name: 'SuperAdminModuleSubSettings',
  components: { ItalicSubheader },
  props: {
    module: {
      type: String,
      required: true,
    },
    settings: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    moduleEnabled: get('admin/additionalModules@:module@enabled'),
    moduleVerboseName: get('admin/additionalModules@:module@verbose_name'),
    settingsValues: get('admin/settingsValues'),
  },
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    changeSingleSetting(name, nV) {
      this.editSingleSetting({
        key: name,
        body: {
          value: nV,
        },
      });
    },
  },
};
</script>
